module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_order.620d9206.svg";